import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentsAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource';
import { IAppointmentAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource1';
import { AppointmentsAvailableTimesServant } from '../servants/appointments_available_times_servant';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';
import { IAppointmentsTabsConfiguration } from '../servants/appointments_tabs_configuration';
import { IAvailableTime } from '../types/appointment_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IDay {
  morning: IAvailableTime[];
  afternoon: IAvailableTime[];
}

angular
  .module('capability-ng-appointments')
  .factory(
    'loadAppointmentsAvailableTimesCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsAvailableTimesDatasource: AppointmentsAvailableTimesDatasource,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
      ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
      ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
      log: any,
      ngAppointmentsAvailableTimesQuery: IQuery,
      ngAppointmentAvailableTimesDatasource1: IAppointmentAvailableTimesDatasource,
      ngAppointmentsAvailableTimesServant: AppointmentsAvailableTimesServant
    ): ICommand => {
      return defineCommand(
        'loadAppointmentsAvailableTimesCommand',
        (deferred: ng.IDeferred<any>, weekOffset: number, invitationId: number): void => {
          ngAppointmentsCommandServant
            .request({
              url: invitationId > 0 ? 'appointment_campaign/scheduler_times' : 'scheduler_times',
              method: 'GET',
              params: ngAppointmentsAvailableTimesServant.requestParams(weekOffset, invitationId)
            })
            .then(
              ({ data }: ng.IHttpPromiseCallbackArg<any>) => {
                const filteredData = _.map(data.days, (day: IDay, key: number) => ({
                  id: _4.toNumber(key + 1),
                  allTimes: [...day.morning, ...day.afternoon]
                }));
                ngAppointmentAvailableTimesDatasource1.clear();
                ngAppointmentAvailableTimesDatasource1.write(filteredData);
                ngAppointmentsTabsConfiguration.stepInComplete('3');
                QueryMediator.runQueries(ngAppointmentAvailableTimesDatasource1);
                deferred.resolve(ngAppointmentsAvailableTimesQuery.result.availableTimesList);
              },
              (rejection: any) => {
                log.error('Unable to get available times');
                deferred.reject();
              }
            );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/load_appointments_available_times_command.ts